import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Avatar from "react-avatar";
import secureLocalStorage from "react-secure-storage";
import DarkMode from "../../../../pages/darkmode/DarkMode";
import Mess from "../../../../pages/Mess";
import AdminUpdateInformation from "./AdminUpdateInformation";
import AdminUpdatePassword from "./AdminUpdatePassword";
import { logout } from '../../../auth/authSlice'
import { increment } from '../../../auth/navSlice'
import { useDispatch } from "react-redux";
import { IoReorderThree } from "react-icons/io5";

const AdminNavbar = ({ urlMain, urlGov, token, role }) => {

    const [employeeName, setEmployeeName] = useState("");
    const [roleName, setRoleName] = useState("");
    const [name, setName] = useState("");
    const [roleId, setRoleId] = useState("");
    const refOpenUpdate = useRef(null);
    const refOpenInformation = useRef(null);
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const handleLogout = () => {
        dispatch(logout())
    };


    const updatePassword = () => refOpenUpdate.current.click();
    const updateInformation = () => refOpenInformation.current.click();

    const passTheName = async () => {
        try {
            const response = await fetch(`${urlMain}/permissions`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${token}`
                }
            })
            const data = await response.json();
            if (data.status === true) {
                setEmployeeName(data.data[0]?.EmployeeName);
                setRoleName(data.data[0]?.RoleName);
            } else if (data.statusCode === 401) {
                dispatch(logout())
            }
        } catch (error) {
            console.error("Error in pass the name:", error);
        }
    };

    const passTheUsers = async () => {
        try {
            const response = await fetch(`${urlGov}/user`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            })
            const data = await response.json();
            if (data.status === true) {
                setName(data.data[0]?.name);
                setRoleId(data.data[0]?.RoleId);
            }

        } catch (error) {
            console.error("Error in pass the users:", error);
        }
    };

    useEffect(() => {
        role === 6 ? passTheUsers() : passTheName();
        // eslint-disable-next-line
    }, []);

    return (
        <>
            <Mess />
            <nav className={`b2b-navbar pt-3 p-2  navbar navbar-expand-lg ${secureLocalStorage.getItem("selectedTheme") === "dark" ? "bg-top-navbar-dark" : "bg-top-navbar-light"}`}>
                <div className="nav_b2b">
                    <div className="pe-auto logo_company nav_logo">
                        <IoReorderThree className="h2 pe-auto" onClick={() => dispatch(increment())} />
                        <Link to="/">
                            <img src="assets/images/ecowrap-logo.png" style={{ width: "180px" }} alt="ecowrap-logo" />
                        </Link>
                    </div>
                    <div className="siz_nav nav_b2b_profile">
                        <ul className="navbar_nav">
                            <li className="nav-item ms-2 me-2">
                                <Avatar round={true} size="35" name={role === 6 ? (name || "Not Available") : (employeeName || "Unknown Person")} />
                            </li>
                            <div className="dropdown ">
                                <div className="nav-item dropdown-toggle text-white" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    <div className="text-left">
                                        <span className="fw-bold">{role === 6 ? (name || "Not Available") : (employeeName || "Unknown Person")}</span>
                                    </div>
                                    <span className="fw-lighter">{role === 6 ? `(${roleId === 6 ? "Government" : ""})` : `(${roleName})`}</span>
                                </div>
                                <ul className="dropdown-menu">
                                    {
                                        role === 6 ? (
                                            <>
                                                <li>
                                                    <button className="dropdown-item" onClick={updateInformation}>
                                                        <i className="fa-solid fa-user"></i> &nbsp; Update Information
                                                    </button>
                                                </li>
                                            </>
                                        ) : (
                                            <>
                                                <li>
                                                    <button className="dropdown-item" onClick={() => navigate("/main:profile")}>
                                                        <i className="fa-solid fa-user"></i> &nbsp; Profile
                                                    </button>
                                                </li>
                                                <li>
                                                    <button className="dropdown-item" onClick={updatePassword}>
                                                        <i className="fa-solid fa-lock"></i> &nbsp; Update Password
                                                    </button>
                                                </li>
                                            </>
                                        )
                                    }
                                    <li>
                                        <button className="dropdown-item" onClick={handleLogout}>
                                            <i className="fa-solid fa-right-from-bracket"></i> &nbsp; Logout
                                        </button>
                                    </li>
                                </ul>
                            </div>
                            <li className="nav-item ms-2 me-2">
                                <DarkMode />
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>

            <AdminUpdateInformation urlGov={urlGov} token={token} refOpenInformation={refOpenInformation} />
            <AdminUpdatePassword urlMain={urlMain} refOpenUpdate={refOpenUpdate} />
        </>
    )
}

export default AdminNavbar;